var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.selectedValue ? "타입 수정" : "타입 추가",
        size: "xl",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "no-enforce-focus": "",
        "hide-footer": "",
      },
      on: { hide: _vm.onBeforeHide },
      model: {
        value: _vm.isVisible,
        callback: function ($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c(
        "form-wizard",
        {
          ref: "refFormWizard",
          staticClass: "mb-3",
          attrs: {
            color: "#7367F0",
            title: null,
            subtitle: null,
            shape: "square",
            "back-button-text": "이전",
            "next-button-text": "다음",
            "finish-button-text": "저장",
            "nav-class": "justify-content-center",
          },
          on: {
            "on-complete": _vm.saveAndClose,
            "on-change": function (_, next) {
              _vm.currentTabIndex = next
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function (ref) {
                var activeTabIndex = ref.activeTabIndex
                var isLastStep = ref.isLastStep
                var nextTab = ref.nextTab
                var prevTab = ref.prevTab
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between w-100" },
                    [
                      activeTabIndex > 0
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-secondary" },
                              on: { click: prevTab },
                            },
                            [_vm._v(" 이전 ")]
                          )
                        : _c("div"),
                      !isLastStep
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: !_vm.hasAnyConditionOn,
                              },
                              on: { click: nextTab },
                            },
                            [_vm._v(" 다음 ")]
                          )
                        : _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.saveAndClose },
                            },
                            [_vm._v(" 저장 ")]
                          ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "tab-content",
            {
              attrs: {
                title: "환자 조건 설정",
                "before-change": _vm.validateStep1,
              },
            },
            [
              _vm.isCondReadonly
                ? _c(
                    "b-alert",
                    {
                      staticClass: "mb-1",
                      attrs: { show: "", variant: "warning" },
                    },
                    [
                      _vm._v(
                        " 1회차 사전 스크리닝이 시작되어 환자 조건 설정을 수정할 수 없습니다. "
                      ),
                    ]
                  )
                : _vm._e(),
              _c("p", { staticClass: "mb-1 text-primary" }, [
                _vm._v(
                  " ⓘ 환자 조건이 광범위할 경우 스크리닝 오류가 발생할 수 있습니다.(예시: 1세 이상, 여성) "
                ),
              ]),
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" 타입 이름 ")]
                      ),
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              placeholder: "타입 이름을 입력하세요",
                              disabled: _vm.isCondReadonly,
                            },
                            model: {
                              value: _vm.form.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" 성별 ")]
                      ),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "custom-control-info",
                              attrs: {
                                switch: "",
                                inline: "",
                                disabled: _vm.isCondReadonly,
                              },
                              model: {
                                value: _vm.form.gender.isUse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.gender, "isUse", $$v)
                                },
                                expression: "form.gender.isUse",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.form.gender.isUse ? "사용" : "사용안함"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.gender.isUse
                    ? _c(
                        "b-row",
                        { staticClass: "mt-1" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-radio-group", {
                                attrs: {
                                  options: [
                                    { text: "남성", value: "M" },
                                    { text: "여성", value: "F" },
                                  ],
                                  disabled: _vm.isCondReadonly,
                                },
                                model: {
                                  value: _vm.form.gender.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.gender, "value", $$v)
                                  },
                                  expression: "form.gender.value",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" 연령 ")]
                      ),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "custom-control-info",
                              attrs: {
                                switch: "",
                                inline: "",
                                disabled: _vm.isCondReadonly,
                              },
                              model: {
                                value: _vm.form.age.isUse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.age, "isUse", $$v)
                                },
                                expression: "form.age.isUse",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.form.age.isUse ? "사용" : "사용안함"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.age.isUse
                    ? _c(
                        "b-row",
                        { staticClass: "mt-1 align-items-center" },
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("span", { staticClass: "mr-50" }, [
                                  _vm._v("만"),
                                ]),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "input-type",
                                      rawName: "v-input-type",
                                      value: "number",
                                      expression: "'number'",
                                    },
                                  ],
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    placeholder: "최소",
                                    disabled: _vm.isCondReadonly,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.clearFieldError("age")
                                    },
                                    blur: function ($event) {
                                      return _vm.validateField("age")
                                    },
                                  },
                                  model: {
                                    value: _vm.form.age.minAge,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.age,
                                        "minAge",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "form.age.minAge",
                                  },
                                }),
                                _c("span", { staticClass: "mx-50" }, [
                                  _vm._v("세 이상 ~ 만"),
                                ]),
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "input-type",
                                      rawName: "v-input-type",
                                      value: "number",
                                      expression: "'number'",
                                    },
                                  ],
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    placeholder: "최대",
                                    disabled: _vm.isCondReadonly,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.clearFieldError("age")
                                    },
                                    blur: function ($event) {
                                      return _vm.validateField("age")
                                    },
                                  },
                                  model: {
                                    value: _vm.form.age.maxAge,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.age,
                                        "maxAge",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "form.age.maxAge",
                                  },
                                }),
                                _c("span", { staticClass: "ml-50" }, [
                                  _vm._v("세 미만"),
                                ]),
                              ],
                              1
                            ),
                            _vm.fieldErrors["age"]
                              ? _c("small", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(_vm.fieldErrors["age"])),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" 진단(질병) ")]
                      ),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "custom-control-info",
                              attrs: {
                                switch: "",
                                inline: "",
                                disabled: _vm.isCondReadonly,
                              },
                              model: {
                                value: _vm.form.disease.isUse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.disease, "isUse", $$v)
                                },
                                expression: "form.disease.isUse",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.form.disease.isUse ? "사용" : "사용안함"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.disease.isUse
                    ? [
                        _c(
                          "b-row",
                          { staticClass: "mt-1 align-items-center" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("span", { staticClass: "mr-1" }, [
                                  _vm._v("질병군 간 교차 조건"),
                                ]),
                                _c("b-form-radio-group", {
                                  attrs: {
                                    options: _vm.andOrOptions,
                                    disabled:
                                      _vm.form.disease.groups.length <= 1 ||
                                      _vm.isCondReadonly,
                                  },
                                  model: {
                                    value: _vm.form.disease.groupCrossCond,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.disease,
                                        "groupCrossCond",
                                        $$v
                                      )
                                    },
                                    expression: "form.disease.groupCrossCond",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._l(_vm.form.disease.groups, function (group, gIdx) {
                          return _c(
                            "div",
                            { key: gIdx, staticClass: "cond-group mt-1" },
                            [
                              _c(
                                "div",
                                { staticClass: "cond-group-header" },
                                [
                                  _c("strong", [
                                    _vm._v("질병군 " + _vm._s(gIdx + 1)),
                                  ]),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-icon p-25",
                                      attrs: {
                                        variant: "flat-danger",
                                        disabled: _vm.isCondReadonly,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.removeGroup(
                                            _vm.form.disease.groups,
                                            gIdx
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: {
                                          icon: "Trash2Icon",
                                          size: "16",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("table", { staticClass: "cond-table w-100" }, [
                                _c("tbody", [
                                  _c("tr", [
                                    _c("td", { staticClass: "cond-label" }, [
                                      _vm._v("질병군 메모"),
                                    ]),
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c("b-form-input", {
                                            staticClass: "mr-2",
                                            staticStyle: { width: "50%" },
                                            attrs: {
                                              placeholder:
                                                "메모를 입력하세요(예: 고혈압)",
                                              disabled: _vm.isCondReadonly,
                                            },
                                            model: {
                                              value: group.memo,
                                              callback: function ($$v) {
                                                _vm.$set(group, "memo", $$v)
                                              },
                                              expression: "group.memo",
                                            },
                                          }),
                                          _c("b-form-radio-group", {
                                            staticClass: "flex-shrink-0",
                                            attrs: {
                                              options: _vm.includeOptions,
                                              disabled: _vm.isCondReadonly,
                                            },
                                            model: {
                                              value: group.include,
                                              callback: function ($$v) {
                                                _vm.$set(group, "include", $$v)
                                              },
                                              expression: "group.include",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", { staticClass: "cond-label" }, [
                                      _vm._v("질병코드"),
                                    ]),
                                    _c("td", [
                                      _c("div", { staticClass: "d-flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex-grow-1" },
                                          [
                                            _c("b-form-textarea", {
                                              attrs: {
                                                placeholder:
                                                  "코드를 쉼표(,)로 구분하여 입력하세요 (코드간 OR 조건 적용)",
                                                rows: "2",
                                                state: _vm.fieldErrors[
                                                  "disease." + gIdx
                                                ]
                                                  ? false
                                                  : null,
                                                disabled: _vm.isCondReadonly,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.clearFieldError(
                                                    "disease." + gIdx
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.validateField(
                                                    "disease",
                                                    gIdx,
                                                    group
                                                  )
                                                },
                                              },
                                              model: {
                                                value: group.codesStr,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    group,
                                                    "codesStr",
                                                    $$v
                                                  )
                                                },
                                                expression: "group.codesStr",
                                              },
                                            }),
                                            _vm.fieldErrors["disease." + gIdx]
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.fieldErrors[
                                                          "disease." + gIdx
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "ml-1 flex-shrink-0" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "outline-primary",
                                                  disabled: _vm.isCondReadonly,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.triggerExcelUpload(
                                                      "disease",
                                                      gIdx
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 엑셀 업로드 ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-50 w-100",
                            attrs: {
                              variant: "outline-primary",
                              disabled: _vm.isCondReadonly,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addGroup(
                                  _vm.form.disease.groups,
                                  "disease"
                                )
                              },
                            },
                          },
                          [_vm._v(" + 질병군 추가 ")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" 처방(약품/수가/재료대/검사) ")]
                      ),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "custom-control-info",
                              attrs: {
                                switch: "",
                                inline: "",
                                disabled: _vm.isCondReadonly,
                              },
                              model: {
                                value: _vm.form.prescription.isUse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.prescription, "isUse", $$v)
                                },
                                expression: "form.prescription.isUse",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.form.prescription.isUse
                                      ? "사용"
                                      : "사용안함"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.prescription.isUse
                    ? [
                        _c(
                          "b-row",
                          { staticClass: "mt-1 align-items-center" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("span", { staticClass: "mr-1" }, [
                                  _vm._v("처방 그룹 간 교차 조건"),
                                ]),
                                _c("b-form-radio-group", {
                                  attrs: {
                                    options: _vm.andOrOptions,
                                    disabled:
                                      _vm.form.prescription.prescriptionGroups
                                        .length <= 1 || _vm.isCondReadonly,
                                  },
                                  model: {
                                    value: _vm.form.prescription.groupCrossCond,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.prescription,
                                        "groupCrossCond",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.prescription.groupCrossCond",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._l(
                          _vm.form.prescription.prescriptionGroups,
                          function (pGroup, pgIdx) {
                            return _c(
                              "div",
                              { key: pgIdx, staticClass: "cond-group mt-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "cond-group-header" },
                                  [
                                    _c("strong", [
                                      _vm._v("처방 그룹 " + _vm._s(pgIdx + 1)),
                                    ]),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn-icon p-25",
                                        attrs: {
                                          variant: "flat-danger",
                                          disabled: _vm.isCondReadonly,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.removePrescriptionGroup(
                                              pgIdx
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: {
                                            icon: "Trash2Icon",
                                            size: "16",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "table",
                                  { staticClass: "cond-table w-100" },
                                  [
                                    _c("tbody", [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          { staticClass: "cond-label" },
                                          [_vm._v("처방군 간 교차 조건")]
                                        ),
                                        _c(
                                          "td",
                                          [
                                            _c("b-form-radio-group", {
                                              attrs: {
                                                options: _vm.andOrOptions,
                                                disabled:
                                                  pGroup.items.length <= 1 ||
                                                  _vm.isCondReadonly,
                                              },
                                              model: {
                                                value: pGroup.itemCrossCond,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    pGroup,
                                                    "itemCrossCond",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pGroup.itemCrossCond",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "px-1 pb-1" },
                                  [
                                    _vm._l(pGroup.items, function (item, iIdx) {
                                      return _c(
                                        "div",
                                        {
                                          key: iIdx,
                                          staticClass: "cond-group mt-1",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cond-group-header",
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  "처방군 " + _vm._s(iIdx + 1)
                                                ),
                                              ]),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn-icon p-25",
                                                  attrs: {
                                                    variant: "flat-danger",
                                                    disabled:
                                                      _vm.isCondReadonly,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.removeGroup(
                                                        pGroup.items,
                                                        iIdx
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: {
                                                      icon: "Trash2Icon",
                                                      size: "16",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "table",
                                            { staticClass: "cond-table w-100" },
                                            [
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "cond-label",
                                                    },
                                                    [_vm._v("처방군 메모")]
                                                  ),
                                                  _c("td", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center",
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          staticClass: "mr-2",
                                                          staticStyle: {
                                                            width: "50%",
                                                          },
                                                          attrs: {
                                                            placeholder:
                                                              "메모를 입력하세요(예: ARB 계열/단백뇨검사)",
                                                            disabled:
                                                              _vm.isCondReadonly,
                                                          },
                                                          model: {
                                                            value: item.memo,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "memo",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.memo",
                                                          },
                                                        }),
                                                        _c(
                                                          "b-form-radio-group",
                                                          {
                                                            staticClass:
                                                              "flex-shrink-0",
                                                            attrs: {
                                                              options:
                                                                _vm.includeOptions,
                                                              disabled:
                                                                _vm.isCondReadonly,
                                                            },
                                                            model: {
                                                              value:
                                                                item.include,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "include",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.include",
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "cond-label",
                                                    },
                                                    [_vm._v("처방코드")]
                                                  ),
                                                  _c("td", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-start",
                                                      },
                                                      [
                                                        _c("v-select", {
                                                          staticStyle: {
                                                            width: "160px",
                                                            "background-color":
                                                              "#fff",
                                                            "flex-shrink": "0",
                                                          },
                                                          attrs: {
                                                            options:
                                                              _vm.codeTypeOptions,
                                                            reduce: function (
                                                              opt
                                                            ) {
                                                              return opt.value
                                                            },
                                                            label: "text",
                                                            clearable: false,
                                                            disabled:
                                                              _vm.isCondReadonly,
                                                          },
                                                          model: {
                                                            value:
                                                              item.codeType,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "codeType",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.codeType",
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex-grow-1 mx-1",
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-textarea",
                                                              {
                                                                attrs: {
                                                                  placeholder:
                                                                    item.codeType ===
                                                                    "CLAIM"
                                                                      ? "코드를 쉼표(,)로 구분하여 입력하세요(코드간 OR 조건 적용)"
                                                                      : "5자리의 원코드(예: D2280)를 쉼표(,)로 구분하여 입력하세요(코드간 OR 조건 적용)",
                                                                  rows: "2",
                                                                  state: _vm
                                                                    .fieldErrors[
                                                                    "presc." +
                                                                      pgIdx +
                                                                      "." +
                                                                      iIdx
                                                                  ]
                                                                    ? false
                                                                    : null,
                                                                  disabled:
                                                                    _vm.isCondReadonly,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clearFieldError(
                                                                        "presc." +
                                                                          pgIdx +
                                                                          "." +
                                                                          iIdx
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.validateField(
                                                                      "presc",
                                                                      pgIdx,
                                                                      iIdx,
                                                                      item
                                                                    )
                                                                  },
                                                                },
                                                                model: {
                                                                  value:
                                                                    item.codesStr,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        item,
                                                                        "codesStr",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "item.codesStr",
                                                                },
                                                              }
                                                            ),
                                                            _vm.fieldErrors[
                                                              "presc." +
                                                                pgIdx +
                                                                "." +
                                                                iIdx
                                                            ]
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .fieldErrors[
                                                                          "presc." +
                                                                            pgIdx +
                                                                            "." +
                                                                            iIdx
                                                                        ]
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex-shrink-0",
                                                          },
                                                          [
                                                            _c(
                                                              "b-button",
                                                              {
                                                                attrs: {
                                                                  variant:
                                                                    "outline-primary",
                                                                  disabled:
                                                                    _vm.isCondReadonly,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.triggerExcelUpload(
                                                                        "prescription",
                                                                        pgIdx,
                                                                        iIdx
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " 엑셀 업로드 "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-50 w-100",
                                        attrs: {
                                          variant: "outline-primary",
                                          disabled: _vm.isCondReadonly,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.addPrescriptionItem(
                                              pgIdx
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" + 처방군 추가 ")]
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          }
                        ),
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-1 w-100",
                            attrs: {
                              variant: "outline-primary",
                              disabled: _vm.isCondReadonly,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addPrescriptionGroup($event)
                              },
                            },
                          },
                          [_vm._v(" + 처방 그룹 추가 ")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-row",
                    { staticClass: "align-items-center" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "font-weight-bold",
                          attrs: { cols: "2" },
                        },
                        [_vm._v(" 검사 결과 ")]
                      ),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "custom-control-info",
                              attrs: {
                                switch: "",
                                inline: "",
                                disabled: _vm.isCondReadonly,
                              },
                              model: {
                                value: _vm.form.lab.isUse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form.lab, "isUse", $$v)
                                },
                                expression: "form.lab.isUse",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.form.lab.isUse ? "사용" : "사용안함"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.lab.isUse
                    ? [
                        _c(
                          "b-row",
                          { staticClass: "mt-1 align-items-center" },
                          [
                            _c(
                              "b-col",
                              [
                                _c("span", { staticClass: "mr-1" }, [
                                  _vm._v("검사 결과군 간 교차 조건"),
                                ]),
                                _c("b-form-radio-group", {
                                  attrs: {
                                    options: _vm.andOrOptions,
                                    disabled:
                                      _vm.form.lab.groups.length <= 1 ||
                                      _vm.isCondReadonly,
                                  },
                                  model: {
                                    value: _vm.form.lab.groupCrossCond,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.lab,
                                        "groupCrossCond",
                                        $$v
                                      )
                                    },
                                    expression: "form.lab.groupCrossCond",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._l(_vm.form.lab.groups, function (group, gIdx) {
                          return _c(
                            "div",
                            { key: gIdx, staticClass: "cond-group mt-1" },
                            [
                              _c(
                                "div",
                                { staticClass: "cond-group-header" },
                                [
                                  _c("strong", [
                                    _vm._v("검사 결과군 " + _vm._s(gIdx + 1)),
                                  ]),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-icon p-25",
                                      attrs: {
                                        variant: "flat-danger",
                                        disabled: _vm.isCondReadonly,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.removeGroup(
                                            _vm.form.lab.groups,
                                            gIdx
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: {
                                          icon: "Trash2Icon",
                                          size: "16",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("table", { staticClass: "cond-table w-100" }, [
                                _c("tbody", [
                                  _c("tr", [
                                    _c("td", { staticClass: "cond-label" }, [
                                      _vm._v("검사 결과군 메모"),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            placeholder:
                                              "메모를 입력하세요(예: AST 50이상)",
                                            disabled: _vm.isCondReadonly,
                                          },
                                          model: {
                                            value: group.memo,
                                            callback: function ($$v) {
                                              _vm.$set(group, "memo", $$v)
                                            },
                                            expression: "group.memo",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c("tr", [
                                    _c("td", { staticClass: "cond-label" }, [
                                      _vm._v("검사코드"),
                                    ]),
                                    _c("td", [
                                      _c("div", { staticClass: "d-flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "flex-grow-1" },
                                          [
                                            _c("b-form-textarea", {
                                              attrs: {
                                                placeholder:
                                                  "5자리의 원코드(예: D2280)를 쉼표(,)로 구분하여 입력하세요(코드간 OR 조건 적용)",
                                                rows: "2",
                                                state: _vm.fieldErrors[
                                                  "lab." + gIdx + ".code"
                                                ]
                                                  ? false
                                                  : null,
                                                disabled: _vm.isCondReadonly,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.clearFieldError(
                                                    "lab." + gIdx + ".code",
                                                    "lab." + gIdx + ".value"
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.validateField(
                                                    "lab-code",
                                                    gIdx,
                                                    group
                                                  )
                                                },
                                              },
                                              model: {
                                                value: group.codesStr,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    group,
                                                    "codesStr",
                                                    $$v
                                                  )
                                                },
                                                expression: "group.codesStr",
                                              },
                                            }),
                                            _vm.fieldErrors[
                                              "lab." + gIdx + ".code"
                                            ]
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.fieldErrors[
                                                          "lab." +
                                                            gIdx +
                                                            ".code"
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "ml-1 flex-shrink-0" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "outline-primary",
                                                  disabled: _vm.isCondReadonly,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.triggerExcelUpload(
                                                      "lab",
                                                      gIdx
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 엑셀 업로드 ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", { staticClass: "cond-label" }, [
                                      _vm._v("결과 수치 범위"),
                                    ]),
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "input-type",
                                                rawName: "v-input-type",
                                                value: "number",
                                                expression: "'number'",
                                              },
                                            ],
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              placeholder: "최소",
                                              state: _vm.fieldErrors[
                                                "lab." + gIdx + ".value"
                                              ]
                                                ? false
                                                : null,
                                              disabled: _vm.isCondReadonly,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.clearFieldError(
                                                  "lab." + gIdx + ".value"
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.validateField(
                                                  "lab-value",
                                                  gIdx,
                                                  group
                                                )
                                              },
                                            },
                                            model: {
                                              value: group.minValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  group,
                                                  "minValue",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "group.minValue",
                                            },
                                          }),
                                          _c("span", { staticClass: "mx-50" }, [
                                            _vm._v("이상 ~"),
                                          ]),
                                          _c("b-form-input", {
                                            directives: [
                                              {
                                                name: "input-type",
                                                rawName: "v-input-type",
                                                value: "number",
                                                expression: "'number'",
                                              },
                                            ],
                                            staticStyle: { width: "100px" },
                                            attrs: {
                                              placeholder: "최대",
                                              state: _vm.fieldErrors[
                                                "lab." + gIdx + ".value"
                                              ]
                                                ? false
                                                : null,
                                              disabled: _vm.isCondReadonly,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.clearFieldError(
                                                  "lab." + gIdx + ".value"
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.validateField(
                                                  "lab-value",
                                                  gIdx,
                                                  group
                                                )
                                              },
                                            },
                                            model: {
                                              value: group.maxValue,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  group,
                                                  "maxValue",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "group.maxValue",
                                            },
                                          }),
                                          _c("span", { staticClass: "ml-50" }, [
                                            _vm._v("미만"),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm.fieldErrors["lab." + gIdx + ".value"]
                                        ? _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.fieldErrors[
                                                    "lab." + gIdx + ".value"
                                                  ]
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]),
                                  _c("tr", [
                                    _c("td", { staticClass: "cond-label" }, [
                                      _vm._v("복수 데이터"),
                                      _c("br"),
                                      _vm._v("처리 기준"),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _c("b-form-radio-group", {
                                          attrs: {
                                            options: _vm.multiMatchOptions,
                                            disabled: _vm.isCondReadonly,
                                          },
                                          model: {
                                            value: group.multiMatch,
                                            callback: function ($$v) {
                                              _vm.$set(group, "multiMatch", $$v)
                                            },
                                            expression: "group.multiMatch",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-50 w-100",
                            attrs: {
                              variant: "outline-primary",
                              disabled: _vm.isCondReadonly,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.addGroup(_vm.form.lab.groups, "lab")
                              },
                            },
                          },
                          [_vm._v(" + 검사 결과군 추가 ")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "tab-content",
            { attrs: { title: "알림 팝업 설정" } },
            [
              _c(
                "b-card",
                { staticClass: "border" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "알림 유지 시간" } },
                    [
                      _c("v-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          options: _vm.delaySecOptions,
                          reduce: function (opt) {
                            return opt.value
                          },
                          label: "text",
                        },
                        model: {
                          value: _vm.form.popupDelaySec,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "popupDelaySec", $$v)
                          },
                          expression: "form.popupDelaySec",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: "알림창 내용" } },
                    [
                      _c(
                        "validation-observer",
                        { ref: "step2Rules" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "알림창 내용",
                              rules: "required|popupContent",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _vm.currentTabIndex === 1
                                      ? _c("tinymce-editor", {
                                          attrs: { "is-table": true },
                                          model: {
                                            value: _vm.form.popupContent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "popupContent",
                                                $$v
                                              )
                                            },
                                            expression: "form.popupContent",
                                          },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("input", {
        ref: "excelInput",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".xlsx,.xls" },
        on: { change: _vm.onExcelFileChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }